import { initializeApp } from 'firebase/app';
import { getFirestore, collection, onSnapshot, query, where, limit, orderBy } from 'firebase/firestore'
import * as React from 'react';
import { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import LinearProgress from '@mui/material/LinearProgress';
import List from '@mui/material/List';
import Button from '@mui/material/Button';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';

// Connect to current firebase project
const firebaseApp = initializeApp({
  apiKey: "AIzaSyBamRPS6NxxPg7lplFrxZd36fLWg9ZUTDY",
  authDomain: "ambient-systems.firebaseapp.com",
  databaseURL: "https://ambient-systems-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "ambient-systems",
  storageBucket: "ambient-systems.appspot.com",
  messagingSenderId: "1001740093061",
  appId: "1:1001740093061:web:b516ca06c0e80199b90bec"
});
const firestore = getFirestore(firebaseApp);

/* Identify the current user */
const user_email = window.localStorage.getItem('user_email');

export default function SummaryPage() {
    const [users, setUsers] = useState([])
    const [connectors, setConnectors] = useState([])
    const [tasks, setTasks] = useState([])
    const [flag, setFlag] = useState(false)

    /* Current date */
    const currDate = new Date().toDateString()

    /* Firestore SDK queries */
    useEffect(() => {
        const userQuery = query(
        collection(firestore, 'users'),
        where('email', '==', user_email)
        );
        const unsubscribe = onSnapshot(userQuery, snapshot => {
            setUsers(snapshot.docs.map(doc => ({id: doc.id, data: doc.data() })))
        })

        return () => {
            unsubscribe()
        }
        }, [])

    useEffect(() => {
        const connectorQuery = query(
            collection(firestore, 'connectors'),
            where('user_email', '==', user_email),
            limit(6)
        );
        const unsubscribe = onSnapshot(connectorQuery, snapshot => {
            setConnectors(snapshot.docs.map(doc => ({id: doc.id, data: doc.data() })))
        })

        return () => {
            unsubscribe()
        }
        }, [])

    useEffect(() => {
        var alertQuery = query(
            collection(firestore, 'alerts'),
            where('email', '==', user_email),
            orderBy("time", "desc"),
            limit(5)
        );
        if (flag) {
            alertQuery = query(
                collection(firestore, 'alerts'),
                where('email', '==', user_email),
                orderBy("time", "desc")
            );
        }
        const unsubscribe = onSnapshot(alertQuery, snapshot => {
            setTasks(snapshot.docs.map(doc => ({id: doc.id, data: doc.data() })))
        })

        return () => {
            unsubscribe()
        }
        }, [flag])

    return (
        <Box>
            {/* Title */}
            <Box>
                <Typography
                    component="h1"
                    variant="h4"
                    color="inherit"
                    noWrap
                    sx={{ flexGrow: 1, mt: 5, ml: 10 }}
                >
                    Today is: {currDate}
                </Typography>

                {users?.map((row) => (
                    <Typography
                        component="h1"
                        variant="h5"
                        color="inherit"
                        noWrap
                        sx={{ flexGrow: 1, mt: 5, ml: 10 }}
                    >
                        Welcome, {row.data.firstName}
                    </Typography>
                ))}
            </Box>
            
            {/* Summary board */}
            <Box sx={{ ml: 5, mt: 5, border: 2, display: 'flex', minHeight: 400, width: '95%' }}>
                <Box sx={{ borderRight: 1, minWidth: 700 }}>
                    <Typography
                        component="h1"
                        variant="h6"
                        color="inherit"
                        noWrap
                        sx={{ flexGrow: 1, ml: 2, mt: 1, mb: 1 }}
                    >
                        Status of your feeds:
                    </Typography>

                    <List sx={{ bgcolor: 'rgba(71, 98, 130, 0.2)' }}>
                    {connectors?.map((row) => (
                        <ListItem divider='true'>
                            <ListItemText primary={row.data.id + '. ' + row.data.name} />
                            <Box sx={{ minWidth: 300, ml: 4, mr: 2 }}>
                                <LinearProgress variant="determinate" value={parseInt(row.data.status.substr(0, row.data.status.length - 1))} />
                            </Box>
                        </ListItem>
                    ))}
                    </List>
                </Box>

                <Box sx={{ width: '100%' }}>
                    <Box sx={{display: 'flex'}}>
                        <Typography
                            component="h1"
                            variant="h6"
                            color="inherit"
                            noWrap
                            sx={{ flexGrow: 1, ml: 2, mt: 1, mb: 1 }}
                        >
                            Alerts:
                        </Typography>
                        <Button onClick={()=>{setFlag(!flag)}}>
                            show all
                        </Button>
                    </Box>

                    <Paper style={{maxHeight: 400, overflow: 'auto'}}>
                        <List sx={{ bgcolor: 'rgba(71, 98, 130, 0.2)' }}>
                        {tasks?.map((row) => (
                            <ListItem divider='true'>
                                <ListItemText primary={row.data.content} secondary={row.data.date}/>
                            </ListItem>
                        ))}
                        </List>
                    </Paper>
                </Box>
            </Box>
        </Box>
    );
}